module.exports = __webpack_public_path__ + "static/img/award1.10f7a52.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/index/award1.png
// module id = y+Kj
// module chunks = 7